import React, { FC, Fragment, useState } from 'react';
import { useQuery } from '@apollo/client';
import { FormControl, Box, Grid, TextField } from '@mui/material';
import Autocomplete from '@mui/material/Autocomplete';
import { getLabsTemplate } from 'apollo/templates/user/query.graphql';
import { Organization } from 'models/organization';
import { useDenthubErrorBoundary } from 'components/shared/denthub-error-boundary/denthub-error-boundary-context';
import { useTranslation } from 'react-i18next';
import ArrowDateFilter from 'components/shared/arrow-date-filter/arrow-date-filter.component';
import { TransportOrderFilter } from 'models/transport';

type MissedTransportOrdersPageActionsProps = {
    onFilterChange: (filters: TransportOrderFilter) => void;
};

const MissedTransportOrdersPageActions: FC<MissedTransportOrdersPageActionsProps> = ({
    onFilterChange,
}: MissedTransportOrdersPageActionsProps) => {
    const { t: translate } = useTranslation(['transport', 'common']);
    const [labId, setLabId] = useState('');
    const [transportDate, setTransportDate] = useState<Date | null>(new Date());
    const { showBoundary } = useDenthubErrorBoundary();
    const { data: { labs } = {}, loading } = useQuery(getLabsTemplate, {
        variables: {
            isTransportEnable: true,
        },
        onError(error) {
            showBoundary(error);
        },
    });

    const handleLabChange = (_: React.SyntheticEvent, lab: Organization | null) => {
        const value = lab ? lab._id : '';
        setLabId(value);
        handleChange(value, transportDate as Date);
    };

    const handleDateChange = (date: Date | null) => {
        setTransportDate(date);
        handleChange(labId, date as Date);
    };

    const handleChange = (labId: string, date: Date) => {
        onFilterChange({
            labId,
            date,
        });
    };

    return (
        <Fragment>
            <Box mb={1} display="flex" alignItems="center">
                <Grid container spacing={1}>
                    <Grid item md={3} sm={6} xs={12}>
                        <FormControl fullWidth margin="dense">
                            <Autocomplete
                                id="labs"
                                disabled={loading}
                                options={labs || []}
                                onChange={handleLabChange}
                                getOptionLabel={(option: Organization) => option.name}
                                renderInput={(params) => <TextField {...params} label={translate('common:LAB')} />}
                            />
                        </FormControl>
                    </Grid>
                    <Grid item md={3} sm={6} xs={12}>
                        <ArrowDateFilter
                            dateValue={transportDate || new Date()}
                            onDateFilterChange={handleDateChange}
                            label={translate('transport:TRANSPORT_DATE')}
                        />
                    </Grid>
                </Grid>
            </Box>
        </Fragment>
    );
};

export default MissedTransportOrdersPageActions;
